<template>
  <div class="container">
    <topNav />
    <el-alert
      v-if="request_state && request_state.agreement_state == 7"
      :title="`Tip：${request_state.remark}，需重新填写`"
      center
      type="error"
    ></el-alert>
    <div class="content">
      <div class="title">在线签约系统</div>
      <el-form :model="form" label-width="170px">
        <el-form-item
          :label="request_state.stateby"
          prop="department_name"
          v-if="request_state && request_state.agreement_state == 5"
        >
          <el-input
            type="textarea"
            :rows="5"
            class="input"
            v-model="request_state.remark"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="单位名称：" prop="department_name">
          <el-input
            class="input"
            v-model="form.department_name"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="subjectioFlag"
          label="单位隶属："
          prop="department_subjection"
        >
          <el-input
            class="input"
            v-model="form.department_subjection"
            :disabled="true"
          ></el-input>
          <div class="upload-tips">
            非地方大型国有单位，请填写单位名称或上级单位名称；地方或非公有制单位，或查询不到单位名称的，请填写单位所在地省份名称。
          </div>
        </el-form-item>
        <el-form-item label="行业：" prop="industry">
          <el-select class="input" v-model="form.industry" :disabled="true">
            <el-option
              v-for="item in industryData"
              :label="item.text"
              :value="item.code"
              :key="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位性质：" prop="employer_type">
          <el-select
            class="input"
            v-model="form.employer_type"
            :disabled="true"
          >
            <el-option
              v-for="item in typeData"
              :label="item.text"
              :value="item.code"
              :key="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统一社会信用代码：" prop="register_number">
          <el-input
            class="input"
            v-model="form.register_number"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="单位地址：" prop="department_region">
          <el-select
            class="input"
            v-model="provinceValue1"
            style="width: 120px; margin-right: 13px"
            :disabled="true"
          >
            <el-option
              v-for="item in provinceData"
              :label="item.text"
              :value="item.code"
              :key="item.code"
            ></el-option>
          </el-select>
          <el-select
            class="input"
            v-model="cityValue1"
            style="width: 120px; margin-right: 13px"
            :disabled="true"
          >
            <el-option
              v-for="item in selectCity1"
              :label="item.text"
              :value="item.code"
              :key="item.code"
            ></el-option>
          </el-select>
          <el-select
            class="input"
            style="width: 120px; margin-right: 12px"
            v-model="form.department_region"
            :disabled="true"
          >
            <el-option
              v-for="item in selectDistrict1"
              :label="item.text"
              :value="item.code"
              :key="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="department_address">
          <el-input
            class="input"
            v-model="form.department_address"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="实际所在地：" prop="actual_location">
          <el-select
            class="input"
            v-model="provinceValue2"
            style="width: 120px; margin-right: 13px"
            :disabled="true"
          >
            <el-option
              v-for="item in provinceData"
              :label="item.text"
              :value="item.code"
              :key="item.code"
            ></el-option>
          </el-select>
          <el-select
            class="input"
            v-model="cityValue2"
            style="width: 120px; margin-right: 13px"
            :disabled="true"
          >
            <el-option
              v-for="item in selectCity2"
              :label="item.text"
              :value="item.code"
              :key="item.code"
            ></el-option>
          </el-select>
          <el-select
            class="input"
            style="width: 120px; margin-right: 12px"
            v-model="form.actual_location"
            :disabled="true"
          >
            <el-option
              v-for="item in selectDistrict2"
              :label="item.text"
              :value="item.code"
              :key="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位联系人：" prop="linkman">
          <el-input
            class="input"
            v-model="form.linkman"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="单位办公电话：" prop="department_phone">
          <el-input
            class="input"
            v-model="form.department_phone"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人手机号：" prop="department_mobile">
          <el-input
            class="input"
            v-model="form.department_mobile"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="单位邮箱：" prop="department_email">
          <el-input
            class="input"
            v-model="form.department_email"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否属于到基层：" prop="is_basic_level">
					<el-radio v-model="form.is_basic_level" label="01" :disabled="true">是</el-radio>
  					<el-radio v-model="form.is_basic_level" label="02" :disabled="true">否</el-radio>
				</el-form-item>
        <!-- <el-form-item
          label="学生档案接收部门："
          prop="profile_address.profile_department"
        >
          <el-input
            class="input"
            v-model="form.profile_address.profile_department"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="学生档案接收单位："
          prop="profile_address.profile_deparment_name"
        >
          <el-input
            class="input"
            v-model="form.profile_address.profile_deparment_name"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="档案接收单位地址："
          prop="profile_address.profile_region"
        >
          <el-select
            class="input"
            v-model="provinceValue3"
            style="width: 120px; margin-right: 13px"
            :disabled="true"
          >
            <el-option
              v-for="item in provinceData"
              :label="item.text"
              :value="item.code"
              :key="item.code"
            ></el-option>
          </el-select>
          <el-select
            class="input"
            v-model="cityValue3"
            style="width: 120px; margin-right: 13px"
            :disabled="true"
          >
            <el-option
              v-for="item in selectCity3"
              :label="item.text"
              :value="item.code"
              :key="item.code"
            ></el-option>
          </el-select>
          <el-select
            class="input"
            style="width: 120px; margin-right: 12px"
            v-model="form.profile_address.profile_region"
            :disabled="true"
          >
            <el-option
              v-for="item in selectDistrict3"
              :label="item.text"
              :value="item.code"
              :key="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="profile_address.profile_address">
          <el-input
            class="input"
            v-model="form.profile_address.profile_address"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="学生档案接收人："
          prop="profile_address.profile_receiver"
        >
          <el-input
            class="input"
            v-model="form.profile_address.profile_receiver"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="接收人联系方式："
          prop="profile_address.profile_receiver_phone"
        >
          <el-input
            class="input"
            v-model="form.profile_address.profile_receiver_phone"
            :disabled="true"
          ></el-input>
        </el-form-item> -->

        <!--户口接收地-->
        <!-- <el-form-item label="户口接收地">
          <el-input
            class="input"
            v-model="form.household_registration"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="户口接收地邮编">
          <el-input
            class="input"
            v-model="form.postal_code"
            :disabled="true"
          ></el-input>
        </el-form-item> -->
        <!--户口接收地结束-->

        <el-form-item label="营业执照：" prop="business_license">
          <img
            v-if="form.business_license"
            :src="form.business_license"
            style="
              width: 182px;
              height: 104px;
              object-fit: scale-down;
              padding: 20px 0 0;
            "
          />
        </el-form-item>

        <el-form-item
          label="企业电子章："
          prop="department_electronic_chapter"
          v-if="need_department_electronic_chapter"
        >
          <img
            v-if="form.department_electronic_chapter"
            :src="form.department_electronic_chapter"
            style="
              width: 182px;
              height: 104px;
              object-fit: scale-down;
              padding: 20px 0 0;
            "
          />
        </el-form-item>
        <el-form-item label="学生姓名：">
					<el-input class="input" v-model="stuInfo.name" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="性别：">
					<el-input class="input" v-model="stuInfo.gender_text" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="身份证号：">
					<el-input class="input" v-model="stuInfo.id_number" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="所属专业：">
					<el-input class="input" v-model="stuInfo.source_major_text" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="学历：">
					<el-input class="input" v-model="stuInfo.education_text" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="入学时间：">
					<el-input class="input" v-model="stuInfo.start_time " :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="毕业时间：">
					<el-input class="input" v-model="stuInfo.end_time " :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="家庭电话：">
					<el-input class="input" v-model="stuInfo.home_phone " :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="联系方式：">
					<el-input class="input" v-model="stuInfo.mobile" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="电子邮箱：">
					<el-input class="input" v-model="stuInfo.email" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="生源地区：">
					<el-input class="input" v-model="stuInfo.native_place_text " :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="家庭住址：">
					<el-input class="input" v-model="stuInfo.home_region_text" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="家庭详细地址：">
					<el-input class="input" v-model="stuInfo.home_address " :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="学生入职工作职位类别：">
					<el-select class="input" v-model="conForm.post_type" :disabled="true">
						<el-option v-for="item in positionData" :label="item.text" :value="item.code" :key="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="试用期：">
					<!-- <el-date-picker :disabled="true" class="input" type="date"  v-model="conForm.additional_info.internship.start_time"
					 value-format="yyyy-MM-dd" style="width: 170px;"></el-date-picker>
					<span style="padding: 0 12px">-</span>
					<el-date-picker :disabled="true" class="input" type="date" v-model="conForm.additional_info.internship.end_time"
					 value-format="yyyy-MM-dd" style="width: 170px;"></el-date-picker> -->
           <div style="display: flex;align-items: center;width: 385px;">
             <el-input-number :disabled="true" class="input" style="flex:1" placeholder="填写天数" v-model="conForm.additional_info.internship_duration" :min="30" :max="180"></el-input-number>
             <span style="margin-left: 20px;min-width: max-content;">天</span>
           </div>
				</el-form-item>
				<el-form-item label="报到期限：">
					<el-date-picker :disabled="true" class="input" type="month"  v-model="conForm.additional_info.noviciate.end_time"
					 value-format="yyyy-MM-dd" style="width: 170px;"></el-date-picker><span style="margin-left: 20px">前</span>
				</el-form-item>
				<el-form-item label="试用期起薪：">
					<el-input :disabled="true" class="input" style="width: 240px" type="number" v-model="conForm.additional_info.probation_salary"></el-input>
					<span style="margin-left: 20px">元/月</span>
				</el-form-item>
				<el-form-item label="转正后起薪：">
					<el-input :disabled="true" class="input" style="width: 240px" type="number" v-model="conForm.additional_info.salary"></el-input>
					<span style="margin-left: 20px">元/月</span>
				</el-form-item>
				<el-form-item label="违约责任：">
					<el-input :disabled="true" type="textarea" :rows="7" class="input" maxlength="130" show-word-limit v-model="conForm.additional_info.responsibility"></el-input>
				</el-form-item>
      </el-form>
    </div>

    <!-- 侧边栏 -->
    <div class="sidebar-btn" @click="sidebar()"></div>
    <div class="sidebar">
      <router-link :to="`/sign/${su_number}`" class="sidebar-on"
        >在线签约</router-link
      >
      <router-link :to="`/signingList/${su_number}`"
        >我的签约(下载就业协议)</router-link
      >
      <div @click="openBox">
        <i class="el-icon-document-copy"></i>《协议书约束》
      </div>
    </div>

    <el-dialog title="协议书约束" :visible.sync="dialogVisible" width="680px">
      <div class="textxy">
        甲乙双方按照国家毕业生就业政策及相关规定，遵守诚实守信原则，在平等自愿，协商一致基础上，达成如下协议：
      </div>
      <div class="textxy">
        一、甲方如实向乙方介绍本单位情况，以及乙方应录（聘）工作岗位情况，现通过对乙方的了解、考核，同意录（聘）用乙方；乙方如实向甲方介绍自己的情况，现通过对甲方的了解，愿意到甲方就业并在本协议约定期限内报到。
      </div>
      <div class="textxy">
        二、本协议是甲乙双方在正式确立劳动人事关系前，经双向选择，双方互为确认对方相关信息真实可靠并承诺在本协议规定的期限内建立劳动人事就业关系的依据。
      </div>
      <div class="textxy">
        三、甲方录（聘）用乙方工作岗位为 ，工作地点为 ，报到期限为 年
        月前，报到地点为 。乙方被录（聘）用后，试用期为 天，试用期起薪为
        元/月，转正后起薪为
        元/月，甲方录（聘）用乙方工作期间，甲方按国家法律、法规、政策规定为乙方缴纳社会保险（包括养老、医疗、失业、工伤、生育等保险），提供相关的福利，以及符合国家规定的劳动安全卫生条件和劳动防护用品。
      </div>
      <div class="textxy">
        四、当乙方因录用为公务员、升学（留学）、参加国家及地方政府项目（选调生、选聘生、大学生志愿服务西部计划、“三支一扶”、农村特岗教师计划、入伍等）就业，而无法履行本协议的，双方另行约定。
      </div>
      <div class="textxy">
        五、甲乙双方应全面履行协议，一方违约，另一方可依法追究其违约责任，并要求其赔偿违约金，违约金另行约定。如甲方或乙方未如实向对方介绍与签订本协议相关的己方情况或隐瞒不良事实，足以影响对方签约意愿的，对方可单方解除本协议，不承担违约责任。
      </div>
      <div class="textxy">
        六、甲乙双方协商一致，可以变更协议中双方约定的条款或解除协议。变更或解除协议，应采用书面形式，由甲乙双方各执一份。符合下列情况之一，经书面告知对方后，本协议解除；1、甲方被撤销或依法宣告破产；2、乙方报到时未取得毕业资格；3、乙方被判处拘役以上刑罚；4、法律、法规、政策规定的其它情况。
      </div>
      <div class="textxy">
        七、甲乙双方因履行本协议发生争议，由甲，乙双方协商解决，或提请有关部门协调解决，也可向人民法院提起诉讼。
      </div>
      <div class="textxy">
        八、未尽事宜，由甲乙双方依据有关法律、法规和政策另行约定。另行约定事宜，视为本协议书的一部分，甲乙双方订立劳动合同（聘用合同）后，本协议自动终止。
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <Footer />
  </div>
</template>

<script>
import topNav from "../layout/top";
import Footer from "../layout/footer";
import { getDict, getSignchip, getSignDetail } from "@/api/login";
export default {
  components: {
    topNav,
    Footer,
  },
  data() {
    return {
      dialogVisible: false,
      aa: 0,
      step: 1,
      need_department_electronic_chapter: "", //是否填企业电子章
      form: {
        is_basic_level: "02", //是否属于到基层
        department_name: "", //单位名称
        department_subjection: "", //单位隶属
        industry: "", //单位行业
        employer_type: "", //单位性质
        register_number: "", //统一社会信用代码
        department_region: "", //单位所在地
        actual_location: "", //实际所在地
        department_address: "", //单位详细地址
        linkman: "", //单位联系人
        department_phone: "", //单位办公电话
        department_mobile: "", //联系人手机号
        department_email: "", //单位邮箱
        business_license: "", //协议图片地址
        department_electronic_chapter: "", //企业电子章
        // profile_address: {
        //   profile_department: "",
        //   profile_deparment_name: "",
        //   profile_receiver: "",
        //   profile_receiver_phone: "",
        //   profile_address: "",
        //   profile_region: "",
        // },
        postal_code: "",
        // household_registration: "",
      },
      request_state: null,
      provinceValue1: "",
      cityValue1: "",
      provinceValue2: "",
      cityValue2: "",
      provinceValue3: "",
      cityValue3: "",
      industryData: [],
      typeData: [],
      statusData: [],
      positionData: [],
      provinceData: [],
      cityData: [],
      districtData: [],
      selectCity1: [],
      selectDistrict1: [],
      selectCity2: [],
      selectDistrict2: [],
      selectCity3: [],
      selectDistrict3: [],
      fileList: [],
      su_number: null,
      sidebarFlag: 1,
      subjectioFlag: false,
      RefusalCause: "", //拒绝原因
      stuInfo: {},
			addInfo: {},
      conForm: {
					post_type: '',
					additional_info: {
						internship: {
							start_time: '',
							end_time: ''
						},
						noviciate: {
							start_time: null,
							end_time: ''
						},
						salary: null,
						probation_salary:null,
						responsibility: ''
					},
					is_accept: true,
					remark: ''
				},
    };
  },
  created() {
    if (this.$route.params.id) {
      this.su_number = this.$route.params.id;
    }
    if (!localStorage.getItem("tokenInfo")) {
      this.$router.push("/login/" + this.su_number);
      return;
    }
    // console.log(this.signManager)
    this.getSignDetail();
    this.getSignInfo();
    this.getType();
    this.getRegion();
    this.getIndustry();
  },
  mounted() {},
  methods: {
    //获取签约信息，判断企业电子章
    async getSignDetail() {
      const res = await getSignchip(this.su_number);
      if (res.need_department_electronic_chapter) {
        this.need_department_electronic_chapter =
          res.need_department_electronic_chapter;
      }
    },
    async getSignInfo() {
      const res = await getSignDetail(this.su_number);
      if (res.request_state && res.request_state.agreement_state == 5) {
        this.request_state = res.request_state;
        if (
          this.request_state.stateby == "college" ||
          this.request_state.stateby == "faculty"
        ) {
          this.request_state.stateby = "高校拒绝原因：";
        } else if (this.request_state.stateby == "department") {
          this.request_state.stateby = "企业拒绝原因：";
        } else if (this.request_state.stateby == "talent") {
          this.request_state.stateby = "人才拒绝原因：";
        }
      }
      if (res.department_info) {
        this.form.is_basic_level = res.department_info.is_basic_level;
        this.form.department_name = res.department_info.department_name;
        this.form.department_subjection =
          res.department_info.department_subjection;
        this.form.linkman = res.department_info.linkman;
        this.form.department_address = res.department_info.department_address;
        this.form.register_number = res.department_info.register_number;
        this.form.department_email = res.department_info.email;
        // this.form.household_registration =
        //   res.department_info.household_registration;
        this.form.postal_code = res.department_info.postal_code;
        if (res.department_info.industry) {
          this.industryData.map((item) => {
            if (item.code == res.department_info.industry) {
              this.form.industry = res.department_info.industry;
            }
          });
        }
        if (res.department_info.employer_type) {
          this.typeData.map((item) => {
            if (item.code == res.department_info.employer_type) {
              this.form.employer_type = res.department_info.employer_type;
            }
          });
        }
        this.form.department_phone = res.department_info.department_phone;
        this.form.department_mobile = res.department_info.department_mobile;
        this.form.department_email = res.department_info.department_email;
        this.form.business_license = res.department_info.business_license;
        this.form.department_electronic_chapter =
          res.department_info.department_electronic_chapter;
        if (res.department_info.department_region) {
          this.form.department_region = res.department_info.department_region;
          setTimeout(() => {
            this.districtData.map((item) => {
              if (item.code == res.department_info.department_region) {
                this.cityValue1 = item.parentcode;
              }
            });
            this.cityData.map((item) => {
              if (item.code == this.cityValue1) {
                this.provinceValue1 = item.parentcode;
              }
            });
            this.cityData.map((item) => {
              if (item.parentcode == this.provinceValue1) {
                this.selectCity1.push(item);
              }
            });
            this.districtData.map((item) => {
              if (item.parentcode == this.cityValue1) {
                this.selectDistrict1.push(item);
              }
            });
          }, 300);
        }
        if (res.department_info.actual_location) {
          this.form.actual_location = res.department_info.actual_location;
          setTimeout(() => {
            this.districtData.map((item) => {
              if (item.code == res.department_info.actual_location) {
                this.cityValue2 = item.parentcode;
              }
            });
            this.cityData.map((item) => {
              if (item.code == this.cityValue2) {
                this.provinceValue2 = item.parentcode;
              }
            });
            this.cityData.map((item) => {
              if (item.parentcode == this.provinceValue2) {
                this.selectCity2.push(item);
              }
            });
            this.districtData.map((item) => {
              if (item.parentcode == this.cityValue2) {
                this.selectDistrict2.push(item);
              }
            });
          }, 300);
        }
        // if (res.profile_address) {
        //   if (res.profile_address.profile_region) {
        //     this.form.profile_address.profile_region =
        //       res.profile_address.profile_region;
        //     setTimeout(() => {
        //       this.districtData.map((item) => {
        //         if (item.code == res.profile_address.profile_region) {
        //           this.cityValue3 = item.parentcode;
        //         }
        //       });
        //       this.cityData.map((item) => {
        //         if (item.code == this.cityValue3) {
        //           this.provinceValue3 = item.parentcode;
        //         }
        //       });
        //       this.cityData.map((item) => {
        //         if (item.parentcode == this.provinceValue3) {
        //           this.selectCity3.push(item);
        //         }
        //       });
        //       this.districtData.map((item) => {
        //         if (item.parentcode == this.cityValue3) {
        //           this.selectDistrict3.push(item);
        //         }
        //       });
        //     }, 300);
        //   }
        //   this.form.profile_address.profile_deparment_name =
        //     res.profile_address.profile_deparment_name;
        //   this.form.profile_address.profile_department =
        //     res.profile_address.profile_department;
        //   this.form.profile_address.profile_receiver_phone =
        //     res.profile_address.profile_receiver_phone;
        //   this.form.profile_address.profile_receiver =
        //     res.profile_address.profile_receiver;
        //   this.form.profile_address.profile_address =
        //     res.profile_address.profile_address;
        // }
      }
      if (res.talent_info) {
					this.stuInfo = res.talent_info
					if(this.stuInfo.start_time){
						this.stuInfo.start_time = this.stuInfo.start_time.split('T')[0]
					}
					if(this.stuInfo.end_time){
						this.stuInfo.end_time = this.stuInfo.end_time.split('T')[0]
					}
				}
				if (res.additional_info) {
					this.addInfo = res.additional_info;
					this.conForm.additional_info = res.additional_info;
				}
    },
    async getIndustry() {
      const res = await getDict("industry_gb");
      if (res) {
        res.map((item) => {
          // if(item.level === 1){
          //     this.industryData.push(item)
          // }
          this.industryData.push(item);
        });
      }
    },
    async getPosition() {
				const res = await getDict('position_type_gb')
				if (res) {
					
					this.positionData = res
					
				}
			},
    async getType() {
      const res = await getDict("employer_type_gb");
      if (res) {
        let arry = [
          "科研助理",
          "部队",
          "国家基层项目",
          "地方基层项目",
          "待就业",
          "不就业拟升学",
          "自主创业",
          "自由职业",
          "升学",
          "出国、出境",
        ];

        let data = res.filter((item) => arry.indexOf(item.text) == -1);
        this.typeData = data;
      }
    },
    async getStatus() {
      const res = await getDict("employment_status");
      if (res) {
        this.statusData = res;
      }
    },
    async getRegion() {
      const res = await getDict("region");
      if (res) {
        this.allRegionData = res;
        res.map((item) => {
          if (item.level === 1) {
            this.provinceData.push(item);
          } else if (item.level === 2) {
            this.cityData.push(item);
          } else if (item.level === 3) {
            this.districtData.push(item);
          }
        });
      }
    },
    sidebar() {
      var sidebar = document.querySelector(".sidebar");
      if (this.sidebarFlag) {
        sidebar.style.display = "block";
        this.sidebarFlag = 0;
      } else {
        sidebar.style.display = "none";
        this.sidebarFlag = 1;
      }
    },

    //
    openBox() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
@media (max-width: 46.875rem) {
  .content {
    width: 20rem !important;

    .step {
      width: 20rem !important;

      .space {
        width: 8rem !important;
      }
    }

    .input {
      width: 10rem !important;
    }
  }
}
.textxy {
  text-indent: 25px;
  line-height: 23px;
}
.content {
  width: 580px;
  margin: 60px auto 20px;

  .title {
    color: #6943ff;
    font-size: 36px;
    font-weight: bold;
    text-align: center;
  }

  .step {
    width: 400px;
    margin: 50px auto;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .space {
      width: 193px;
      height: 1px;
      background-image: linear-gradient(to right, #5e4fff, #e9e9e9);
      margin-top: -14px;
    }

    .step1,
    .step2 {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 56px;
        height: 56px;
      }

      span {
        display: block;
        color: #cccccc;
        font-size: 14px;
        padding-top: 2px;
      }
    }
  }

  .input {
    width: 385px;

    .el-input__inner {
      height: 34px;
      line-height: 34px;
      border-radius: 0;
    }
  }

  .upload {
    padding: 0 10px;
    color: #ffffff;
    font-size: 14px;
    margin-right: 14px;
    line-height: 30px;
    cursor: pointer;
  }

  .upload-tips {
    margin: 0;
    padding-top: 0.625rem;
    line-height: 20px;
    font-size: 0.75rem;
    color: #f56c6c;
  }

  .submit-btn {
    width: 160px;
    height: 40px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    background: #5e4fff;
    cursor: pointer;
  }

  .alertBox {
    position: fixed;
    font-size: 24px;
    height: 212px;
    width: 385px;
    border-radius: 0.25rem;
    background-color: white;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    background: url("../../assets/image/downLineBg.png") no-repeat;
    background-size: 385px 212px;
  }

  .over {
    position: fixed;
    width: 100%;
    height: 100%;
    opacity: 0.4; //透明度为70%
    filter: alpha(opacity=70);
    top: 0;
    left: 0;
    z-index: 999;
    background-color: #111111;
  }

  .alertBox_title {
    width: 100%;
    height: 25px;
    line-height: 25px;
    color: #333333;
    font-size: 18px;
    text-align: center;
    margin-top: 40px;
  }

  .alertBox_content {
    width: 300px;
    height: 60px;
    line-height: 20px;
    font-size: 16px;
    color: #333333;
    margin: 10px auto 22px auto;
    overflow-y: auto;
  }

  .alertBox_commit {
    width: 160px;
    height: 36px;
    background-color: #5e4fff;
    color: white;
    text-align: center;
    line-height: 36px;
    margin: 0 auto;
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
  }

  .alertBox_title img {
    width: 20px;
    height: 20px;
    margin-right: 4px;
  }

  .colseModel {
    width: 15px;
    height: 14px;
    position: absolute;
    right: 12px;
    top: 12px;
    cursor: pointer;
  }
}

@media (max-width: 46.875rem) {
  .content .upload {
    padding: 0px 5px;
    margin-right: 5px;
  }
}

// 预览

.preview {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
}

.preview div,
.preview-img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.preview div {
  height: 37.5rem;
  width: 37.5rem;
  border-radius: 0.625rem;
  background: #fff;
}

.preview-img {
  width: 34.375rem;
  height: 34.375rem;
}

.preview-close {
  position: absolute;
  right: 1.5rem;
  top: 1.5rem;
  height: 1.5rem;
  width: 1.5rem;
  z-index: 99;
}

@media (max-width: 46.875rem) {
  .preview div {
    width: 22rem;
    height: 22rem;
  }

  .preview-img {
    width: 20rem;
    height: 20rem;
  }
}

.refuse_sign .el-form-item__content {
  margin-left: 0 !important;
  width: 100% !important;
}

.refuse_sign .el-form-item {
  display: flex !important;
  flex-wrap: wrap !important;
}

.refuse_sign .el-form-item .input {
  width: 100%;
}
</style>
